// Czech texts and small formatters for the Zásilky verification gate.
import { CODES } from '../../utils/shipmentsApi';

export const CODE_LENGTH = 6;
export const DEFAULT_VALIDITY_MIN = 10;

// "42 s" up to 90 s, otherwise whole minutes rounded up ("15 min")
export function formatWait(seconds) {
  const s = Math.max(0, Math.ceil(seconds));
  return s <= 90 ? `${s} s` : `${Math.ceil(s / 60)} min`;
}

// "1 minuta" / "2 minuty" / "10 minut"
export function minutesText(n) {
  if (n === 1) return '1 minuta';
  if (n >= 2 && n <= 4) return `${n} minuty`;
  return `${n} minut`;
}

// Czech "attempts left" sentence: Zbývá 1 pokus / Zbývají 2-4 pokusy / Zbývá 5 pokusů
export function attemptsLeftText(n) {
  if (n === 1) return 'Zbývá 1 pokus.';
  if (n >= 2 && n <= 4) return `Zbývají ${n} pokusy.`;
  return `Zbývá ${n} pokusů.`;
}

// "14:32" for today, "29. 10. 14:32" for another day
export function formatWhen(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const time = d.toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit' });
  return d.toDateString() === new Date().toDateString()
    ? time
    : `${d.getDate()}. ${d.getMonth() + 1}. ${time}`;
}

// Quiet line under the protected shell: when the verification runs out (idle / absolute limit), '' if unknown
export function expiryText(status) {
  const idle = status?.idleExpiresAt ? formatWhen(status.idleExpiresAt) : '';
  const hard = status?.expiresAt ? formatWhen(status.expiresAt) : '';
  if (idle && hard) return `Ověření vyprší při nečinnosti v ${idle}, nejpozději v ${hard}.`;
  if (idle) return `Ověření vyprší při nečinnosti v ${idle}.`;
  if (hard) return `Ověření platí nejpozději do ${hard}.`;
  return '';
}

export const digitsOnly =(value) => String(value || '').replace(/\D/g, '').slice(0, CODE_LENGTH);

// Turns an api() error into { text, waitSeconds?, lock?, clearCode? } for the gate.
// waitSeconds blocks the "send" button, lock additionally blocks the confirm button.
export function describeError(err) {
  const wait = Number(err?.data?.retryAfterSeconds) || 0;
  switch (err?.code) {
    case CODES.INVALID_CODE: {
      const left = Number(err.data?.attemptsLeft);
      if (Number.isFinite(left) && left <= 0) {
        return { text: 'Nesprávný kód. Počet pokusů je vyčerpán, pošlete si nový kód.', clearCode: true };
      }
      const rest = Number.isFinite(left) ? ` ${attemptsLeftText(left)}` : '';
      return { text: `Nesprávný kód.${rest}`, clearCode: true };
    }
    case CODES.CODE_EXPIRED:
      return { text: 'Platnost kódu vypršela. Pošlete si nový kód.', clearCode: true };
    case CODES.LOCKED:
      return {
        text: wait ? `Příliš mnoho pokusů, zkuste to za ${formatWait(wait)}.` : 'Příliš mnoho pokusů, zkuste to později.',
        waitSeconds: wait, lock: true, clearCode: true,
      };
    case CODES.RATE_LIMITED:
      return {
        text: wait ? `Příliš mnoho žádostí o kód, zkuste to za ${formatWait(wait)}.` : 'Příliš mnoho žádostí o kód, zkuste to později.',
        waitSeconds: wait,
      };
    case CODES.MAIL_NOT_CONFIGURED:
      return { text: 'Odesílání e-mailů není nastavené. Kontaktujte správce.' };
    case CODES.MAIL_FAILED:
      return { text: 'E-mail s kódem se nepodařilo odeslat. Zkuste to za chvíli znovu.' };
    case CODES.NO_ACCESS:
      return { text: 'Nemáte oprávnění k modulu Zásilky.' };
    default:
      return { text: err?.status === 400 ? 'Zadejte šestimístný kód.' : (err?.message || 'Něco se nepovedlo, zkuste to znovu.') };
  }
}
